import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from '../components/Headers/AuthHeader';
import { Box,} from '@mui/material';
const AuthLayout = () => (
  <>
<Box sx={{}}>
    <AuthHeader />
    <main style={{ padding: '0px',margin:"0px" }}>
      <Outlet />
    </main>
    </Box>
  </>
);

export default AuthLayout;